import settings from '@/constants/constants';
import useGetZendeskToken from '@/hooks/zendesk/useGetZendeskToken';
import { AlternaleafChatbot } from '@montugroup/chatbots';

interface ChatbotWidgetProps {
  anonymous?: boolean;
}

export function ChatbotWidget({ anonymous, ...props }: ChatbotWidgetProps) {
  if (anonymous) {
    return <UnauthenticatedWidget {...props} />;
  }

  return <AuthenticatedWidget {...props} />;
}

function UnauthenticatedWidget() {
  return <AlternaleafChatbot apiKey={settings.chatbotApiKey} />;
}

function AuthenticatedWidget() {
  const { data } = useGetZendeskToken();
  const zendeskToken = data?.token;

  return (
    <AlternaleafChatbot
      zendeskToken={zendeskToken}
      apiKey={settings.chatbotApiKey}
      customerType="internal"
      shadow={true}
    />
  );
}
